var map = {
	"./en_US3.png": "rnAk",
	"./zh_CN3.png": "3sdA",
	"./zh_HANT3.png": "nIDr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+BiB";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile ^\.\/.*3\.png$
// module id = +BiB
// module chunks = 1